import CustomerPage from '@/pages/customer/customer-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/customers/$id')({
  component: CustomerPage,
});
